import "./svg/nav-forkandknife.svg"

export default {
    name: "nav-forkandknife",
    viewBox: "24 24",
}
